const getVouchersList = (state) => {
  return state.main.voucherState.vouchers
}

const getFetchVouchersListRequestState = (state) => {
  return state.main.voucherState.fetchVouchersListRequestState
}

const getPaginationOffset = (state) => {
  return state.main.voucherState.paginationOffset
}

const getVouchersFilter = (state) => {
  return state.main.voucherState.vouchersFilter
}

const getUpdateVoucherRequestState = (state) => {
  return state.main.voucherState.updateVoucherRequestState
}
const getAddVoucherRequestState = (state) => {
  return state.main.voucherState.addVoucherRequestState
}
const getVouchersCount = (state) => {
  return state.main.voucherState.vouchersCount
}
const getVouchersCountRequestState = (state) => {
  return state.main.voucherState.fetchVouchersCountRequestState
}
const getDeleteVoucherRequestState = (state) => {
  return state.main.voucherState.deleteVoucherRequestState
}
const getAllVouchers = (state) => {
  return state.main.voucherState.allVouchers
}
const getFetchAllVouchersRequestState = (state) => {
  return state.main.voucherState.fetchAllVouchersRequestState
}

const VoucherSelectors = {
  getVouchersList,
  getFetchVouchersListRequestState,
  getPaginationOffset,
  getVouchersFilter,
  getUpdateVoucherRequestState,
  getAddVoucherRequestState,
  getVouchersCount,
  getVouchersCountRequestState,
  getDeleteVoucherRequestState,
  getAllVouchers,
  getFetchAllVouchersRequestState,
}

export default VoucherSelectors
